export const getIsDealerFinanceVehicle3Way = (vehicle) => {
    const { dealerFinancing, financingProduct } =
        vehicle?.financingPrecalc?.searchFilters || {};

    return JSON.parse(dealerFinancing || 'false') &&
        financingProduct === 'threeWayFinancing';
}
